import React from "react";
import CalendarPickup from "../../../component/Calendar/CalendarPickup";


const CalendarPickupScreen = () => {
  return (
    <div>
      <CalendarPickup />
    </div>
  );
};

export default CalendarPickupScreen;
